import React from "react";

const ReadMoreEnrico = () => {
  return (
    <div>
      <div>
        <p>
        Dr. Fiaccadori confirmed that there were some cases of cadmium intoxication in Italy, 
        but they were nottreated by him. They were treated by the medicine department, and were 
        cases of chronic intoxication in workers who were specifically welding and galvanizing.
        </p>
      <p className="mb-2">
        After hearing a presentation about our project he stated that an advantage of our solution is its modularity that 
        would allow it to be applied to different contaminants. He also positively approved of the attention to the horizontal
        gene transfer which was one of his concerns about the project. 
        </p>
      <p className="mb-2">
        He advised us to pay attention to the percentage of cadmium removed from our probiotic as intestinal absorption 
        is low compared to the quantities ingested. For us, this was very valuable advice for the experiments to conduct 
        if we want the product to be one day approved and verify that it would really be a solution to chronic intoxications. 
        Another important input for future applications of our probiotic was to pay attention to patients that have intestinal 
        dysbiosis because even if our bacteria would stay for a limited amount of time in the gut the delicate equilibrium of 
        their microbiota could be highly impacted and also some have partially permeable intestinal walls and this could mean 
        that the bacteria would spread in the rest of the organism. 
        </p>
      <p className="mb-2">
        The conversation continued with the topic of clinical approval; Enrico Fiaccadori gave us his personal advice as he 
        declared himself not a pharmaceutical approval expert. In his opinion, the fact that 48C <i>E.Coli</i> would stay in the 
        organism for about 48 hours is beneficial to its approval by the health agencies. Nevertheless, our product would have 
        to be approved as a drug and not a supplement, so the item would be longer. 
        </p>
      <p className="mb-2">
        This conversation was very useful for us as it confirmed once again that chronic cadmium intoxication is an issue and
         that our probiotic could be a solution. At the same time, it brought to our attention some experiments that are 
         essential for its approval and efficiency: testing for horizontal gene transfer, the percentage of Cd that is
         removed, and paying attention to special pathological cases that may have to be excluded from 
         the use of this probiotic.
        </p>

      </div>
    </div>
  );
};

export default ReadMoreEnrico;
